export default __webpack_public_path__ + "static/media/screenshot.5205cadd.jpg";